import { render, staticRenderFns } from "./SwRightNav.vue?vue&type=template&id=57fc123e&scoped=true&"
import script from "./SwRightNav.vue?vue&type=script&lang=js&"
export * from "./SwRightNav.vue?vue&type=script&lang=js&"
import style0 from "./SwRightNav.vue?vue&type=style&index=0&id=57fc123e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57fc123e",
  null
  
)

export default component.exports